/* eslint-disable @typescript-eslint/naming-convention */
import { Put } from 'config/apiServiceConfig'
import apiServices from 'config/apiServiceApiGateway'
import { buildQueryParams } from 'utils/helpers/queryParams'
import { ProductInventoryStatusNoteType } from '../@types/Product'
import { InventoryProductDetailInterface } from '../@types/Inventory'

export type GetProductInventoriesParamsType = Partial<{
  'filter.location_ids': number[]
  'filter.location_types': string[]
  'filter.search_product': string
  'filter.search_rack': string
  'filter.search_package': string
  'filter.cloud_kitchen'?: '' | boolean
  'pagination.sort': number
  'pagination.direction': 'asc' | 'desc'
  'pagination.page_index': number
  'pagination.page_size': number
}>

export type ProductInventoryItemType = {
  location_name: string
  location_type: string
  is_virtual_bom_component: boolean
  grammation: string
  stock: number
  reserved_stock: number
  product_name: string
  bom_category: string
  price: string
  product_image: string
  product_sku_number: string
  location_id: number
  is_active: boolean
  update_price: boolean
  cloud_kitchen: boolean
  business_taggings: {
    id: number
    key: 'SCHEDULE_DELIVERY' | 'ASTRO_GO' | 'QUICK_COMMERCE'
    type: string
    value: string
  }[]
  product_id: number
  total_stock: number
  uom: string
  external_reserved_stock: number
}

export type GetProductInventoriesResponseType = {
  data: ProductInventoryItemType[]
  pagination: {
    page_index: number
    direction: 'asc' | 'desc'
    sort: string
    page_size: number
  }
}

export type PutInventoryLocationPayloadType = {
  product_price: string
}

export type GetProductInventoriesDetailsQueryParamsType = {
  location_id: number
  product_ids: number
  expiry_date_from?: string
  expiry_date_to?: string
  'pagination.page_size': number
  'pagination.page_index': number
  'pagination.sort'?: string
}

export const getProductInventoriesAPI = (params?: GetProductInventoriesParamsType) =>
  apiServices.Get<GetProductInventoriesResponseType, true>({
    url: `/wims/internal/v1/inventories`,
    params,
    config: {
      paramsSerializer: {
        serialize: (p) => buildQueryParams(p).toString(),
      },
    },
  })

export const getProductInventoriesDetailsAPI = (
  params: GetProductInventoriesDetailsQueryParamsType,
) =>
  apiServices.Get<InventoryProductDetailInterface[]>({
    url: `/wims/internal/v1/inventories/detail`,
    params,
  })

export const putInventoryLocationAPI = (
  locationId: number,
  productId: number,
  payload: PutInventoryLocationPayloadType,
) =>
  Put({
    url: `/api/inventory/${locationId}/${productId}`,
    data: payload,
  })

export const putInventoryLocationStatusAPI = (
  locationId: number,
  productId: number,
  isActive: boolean,
) =>
  Put({
    url: `/api/inventory/${locationId}/${productId}/active`,
    data: {
      is_active: isActive,
    },
  })

export type GetInventoryStatusNotesQueryParamsType = {
  page_index: number
  page_size: number
  inventory_status_id?: string | number
}

export const getInventoryStatusNotesApi = (params: GetInventoryStatusNotesQueryParamsType) =>
  apiServices.Get<ProductInventoryStatusNoteType[]>({
    url: '/wims/internal/v1/inventory-status-notes',
    params,
  })
